import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-orange-600 font-semibold tracking-wide uppercase text-xs mb-2">Mine specialer</h2>
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">Professionel brolægning og anlæg</h3>
          <div className="w-16 h-1 bg-orange-600 mx-auto rounded-full"></div>
          <p className="mt-3 text-slate-600 text-sm max-w-2xl mx-auto">
            Jeg leverer høj kvalitet i alle projekter, uanset om det er en lille terrasse eller en komplet indkørsel.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {services.map((service) => {
            const IconComponent = Icons[service.icon];
            return (
              <Link 
                key={service.id} 
                to={`/ydelser/${service.slug}`}
                className="group relative overflow-hidden rounded-xl shadow-md aspect-[16/10] sm:aspect-[4/5] flex items-end transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
              >
                {/* Background Image */}
                <div className="absolute inset-0 z-0">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Overlay Gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 p-4 md:p-6 w-full">
                  <div className="w-10 h-10 md:w-11 md:h-11 bg-orange-600/20 backdrop-blur-md border border-orange-500/30 rounded-lg flex items-center justify-center mb-3 md:mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                    {IconComponent && <IconComponent className="h-5 w-5 md:h-6 md:w-6 text-orange-500 group-hover:text-white transition-colors" />}
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-white mb-1.5">{service.title}</h4>
                  <p className="text-slate-300 text-sm md:text-base leading-relaxed mb-3 md:mb-4 line-clamp-2 group-hover:text-white transition-colors">
                    {service.shortDescription}
                  </p>
                  <div className="inline-flex items-center text-orange-400 font-semibold group-hover:text-orange-300 transition-colors gap-1.5 text-sm md:text-base">
                    Læs mere <ArrowRight className="h-4 w-4 md:h-5 md:w-5 transform group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
